import React, {useState} from "react";
import {withAppStore} from "../../context";

import Step from "../dynamic";

import "./style.scss";
import Close from "../icons/Close";
import {setToastHandler} from "./NavigationManager";
import classNames from "classnames";
import {detectActiveStep} from "../../utils/common";
import Arrow from "../icons/Arrow";
import Switch from "../common/Switch";
import Lang from "../icons/Lang";

export default withAppStore((props) => {
  const {
    config: {
      product: {
        gender,
        business: {
          config: {
            direction,
            modalClass,
            size,
            sizeChangeIntegration,
            appClass,
            base: {
              hide_citation,
            } = {},
            interview: {measure_range},
          },
        },
      },
      localizations,
      steps,
    },
    data: {
      activeStep,
      modalStatus,
      lang,
      profiles: {
        one: {data: profile},
      },
    },
    actions: {setHideModal, setSetting, changeLanguage},
  } = props;

  const [toast, setToast] = useState({show: false});
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);

  const handleFocusIn = (event) => {
    if (event.data === "closeModal") {
      handleCloseModal();
    }
  };

  React.useEffect(() => {
    if (activeStep === null) {
      setSetting("activeStep", detectActiveStep(profile, gender, steps, measure_range));
    }
  }, [activeStep]);

  React.useEffect(() => {
    window.addEventListener("message", handleFocusIn);
    document.addEventListener("keydown", handleEscape);
    return () => {
      window.removeEventListener("message", handleFocusIn);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const showToast = ({message, messageType, delay = 1}) => {
    setToast({
      message,
      messageType,
      show: true,
    });
    setTimeout(() => {
      setToast({
        message,
        messageType,
        show: false,
      });
    }, delay * 1000);
  };

  setToastHandler({
    handler: {
      show: showToast,
    },
    forceUpdate: true,
  });

  const handleEscape = (event) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setHideModal("modalStatus", "hide");
  };

  return (
    <div
      className={classNames(
        `modal--${modalStatus}`,
        direction === "rtl" && "rtl",
        appClass
      )}
    >
      <div className={`modal ${modalClass} modal--${modalStatus}`}>
        <div
          className="modal__overlay"
          onClick={() => {
            handleCloseModal();
          }}
        >
          &nbsp;
        </div>
        <div className={`modal__content modal--${size}`}>
          <div className="modal__header">
            <div
              className={classNames(
                "toast",
                toast.show && "toast--open",
                toast?.messageType === "error" ? "toast--error" : ""
              )}
            >
              <div className={`toast__text`}>{toast?.message}</div>
            </div>
          </div>
          <div className={classNames("modal__body")}>
            <div
              className={classNames("language__overlay", {
                open: isLanguageOpen,
              })}
            >
              &nbsp;
            </div>
            <div
              className={classNames("language__modal", {
                open: isLanguageOpen,
              })}
              onClick={(event) => {
                event.preventDefault();
                if (event.target === event.currentTarget) {
                  setIsLanguageOpen(false);
                }
              }}
            >
              <div className="language__options">
                <Switch
                  options={[
                    {value: -1, label: "Site language"},
                    ...localizations,
                  ]}
                  value={lang}
                  styleSwitch={["switch--vertical", "switch--noneBorder"]}
                  onChange={(value) => {
                    changeLanguage(value);
                    setTimeout(() => {
                      setIsLanguageOpen(false);
                    }, 300);
                  }}
                />
              </div>
            </div>

            <button
              className="modal__close"
              onClick={() => {
                handleCloseModal();
              }}
            >
              <Close/>
            </button>

            {sizeChangeIntegration.enabled && (
              <div
                className={classNames(`step sizeChart`, {
                  active: activeStep === -2,
                })}
              >
                <Step id={"sizeChart"}/>
              </div>
            )}

            <div
              className={classNames("step", "EnterMeasureManually", {
                active: activeStep === -1,
              })}
            >
              <Step id="EnterMeasureManually"/>
            </div>
            {steps.map((step, index) => (
              <div
                className={classNames("step", step.id, {
                  active: activeStep === index,
                })}
                key={step.id}
              >
                <Step id={step.id} stepConfig={step.config}/>
              </div>
            ))}
          </div>
          <div className="modal__footer"></div>
          <div className="modal__citation">
            <div>
              <a
                className="modal__citationLink"
                target="_blank"
                rel="noreferrer"
                href="https://robosize.com/privacy"
              >
                Privacy & Policy
              </a>{" "}
              {
                !hide_citation && (
                  <>
                    | Powered by{" "}
                    <a
                      className="modal__citationLink"
                      href="https://robosize.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      RoboSize
                    </a>
                  </>
                )
              }
            </div>
            <div className="language">
              <div
                className="language__label"
                onClick={() => {
                  setIsLanguageOpen(!isLanguageOpen);
                }}
              >
                <Lang className="language__icon"/>
                {[{value: -1, label: "Site language"}, ...localizations].map(
                  (supportedLanguage, index) => {
                    return (
                      lang === supportedLanguage.value && (
                        <span key={`${supportedLanguage.value}-${index}`}>
                          {supportedLanguage.label}
                        </span>
                      )
                    );
                  }
                )}
                <Arrow
                  className={classNames("language__arrow", {
                    "language__arrow--open": isLanguageOpen,
                  })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
